import React from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
interface CTAButtonProps extends ButtonProps {
  children: React.ReactNode;
}
export function CTAButton({
  children,
  ...props
}: CTAButtonProps) {
  return <Button size="lg" bg="red.600" color="white" fontSize={{
    base: 'xs',
    sm: 'sm',
    md: 'md'
  }} fontWeight="bold" py={{
    base: 4,
    md: 6
  }} px={{
    base: 4,
    md: 6
  }} borderRadius="xl" shadow="2xl" borderWidth="2px" borderColor="red.500" _hover={{
    bg: 'red.700',
    transform: 'scale(1.02)',
    shadow: '2xl',
    borderColor: 'red.400'
  }} _active={{
    bg: 'red.800',
    transform: 'scale(0.98)'
  }} transition="all 0.2s" w={{
    base: 'full',
    md: 'auto'
  }} whiteSpace="normal" textAlign="center" lineHeight="1.3" minH={{
    base: '60px',
    md: '70px'
  }} {...props} data-id="element-216">
      {children}
    </Button>;
}